import type { ReactNode } from "react";
import { Logo } from "@/components/layout/Logo";

/**
 * Zentrierte Karte für alle Auth-Ansichten (Login, Registrierung/Aktivierung,
 * Passwort vergessen/zurücksetzen, Erstanmeldung-Passwortänderung). 1:1 aus dem
 * gemeinsamen Markup in src/components/CustomerAuth.js portiert
 * (.portal-container / .login-center-card / .logo-container / .logo-badge).
 */
export function AuthCardLayout({ children }: { children: ReactNode }) {
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="flex min-h-[calc(100vh-var(--header-h))] w-full items-center justify-center p-8 max-sm:p-4"
    >
      <h1 className="sr-only">cleverfleet Onboarding-Portal</h1>
      <div className="w-full max-w-[520px] rounded-lg border border-border border-t-[5px] border-t-primary bg-card p-12 shadow-lg max-dialog:p-5">
        <div className="mb-14 flex items-center gap-3 text-primary">
          <Logo className="h-14" />
          <span className="rounded-full bg-primary px-2 py-[0.2rem] text-xs font-normal text-primary-foreground">
            Onboarding
          </span>
        </div>
        {children}
      </div>
    </main>
  );
}
